import { Reveal } from "../Reveal";
import { COLLABORAZIONI } from "../../data/content";
import { scrollToId } from "../Navbar";

export const Collaborare = () => (
  <section
    id="collaborare"
    data-testid="collaborare-section"
    className="relative border-t border-[#16181a]/12"
  >
    <div className="mx-auto max-w-7xl px-6 py-24 md:px-14 md:py-32">
      <div className="grid grid-cols-12 gap-8">
        <Reveal className="col-span-12 md:col-span-5">
          <div className="flex items-baseline gap-4">
            <span className="font-display text-2xl italic text-[#c0442b]">04</span>
            <span className="overline">Collaborare</span>
          </div>
          <h2 className="mt-6 font-display text-4xl font-light leading-[1.05] tracking-tight text-[#16181a] md:text-6xl">
            Progetti in cui posso essere <span className="italic text-[#c0442b]">utile</span>.
          </h2>
          <p className="mt-8 max-w-md font-body text-base leading-relaxed text-[#2a2b2d]">
            Preferisco parlare di esigenze prima che di formule. Se hai un progetto in mente —
            piccolo o articolato — raccontamelo. Da lì capiamo insieme se e come lavorare.
          </p>
          <button
            data-testid="collab-cta"
            onClick={() => scrollToId("contatti")}
            className="group mt-10 inline-flex items-center gap-3 bg-[#16181a] px-7 py-4 font-body text-sm font-semibold uppercase tracking-widest text-[#f0ead9] transition-colors duration-300 hover:bg-[#c0442b]"
          >
            Raccontami la tua esigenza
            <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
          </button>
        </Reveal>

        <div className="col-span-12 md:col-span-6 md:col-start-7">
          <ul className="divide-y divide-[#16181a]/15 border-y border-[#16181a]/15">
            {COLLABORAZIONI.map((c, i) => (
              <li key={c.title}>
                <Reveal delay={i * 0.06}>
                  <div className="flex items-start gap-6 py-6 md:py-8">
                    <span className="font-display text-lg italic text-[#c0442b]">
                      0{i + 1}
                    </span>
                    <div>
                      <h3 className="font-display text-2xl font-light text-[#16181a] md:text-3xl">
                        {c.title}
                      </h3>
                      <p className="mt-2 max-w-lg font-body text-sm leading-relaxed text-[#2a2b2d] md:text-base">
                        {c.desc}
                      </p>
                    </div>
                  </div>
                </Reveal>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
